export enum UnitOptionAvailabilityActivator {
  OtherUnit = 0,
  SameUnit = 1,
  ArmyOrganisation = 2,
  SizeMin = 3,
}
